module.exports = __webpack_public_path__ + "img/start_contract.eead0bd0.svg";